import { get } from "lodash";
import React from "react";
import { diffWords } from 'diff';

const htmlToText = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const TemplateDiff = props => {
    const { default_entry, block } = props;
    const id = block.id;
    // search for corresponding id in default_entry 
    const arr = get(default_entry, 'json_data', []);
    const old = arr.find(item => item.id === id);
    if (!old) return null;

    const handleExport = () => {
        const new_content = block.content;
        const old_content = old.content;
        const oldText = htmlToText(old_content || '');
        const newText = htmlToText(new_content || '');
    
        const diff = diffWords(oldText, newText);
        const highlighted = diff
            .map((part) => {
            if (part.added)
                return `<span style="background: #c6f6d5">${part.value}</span>`;
            if (part.removed)
                return `<span style="background: #fed7d7; text-decoration: line-through">${part.value}</span>`;
            return part.value;
            })
            .join('');
    
        return <>
        <hr />
        <span
                        style={{padding: 10}}
                        className="hoverable-gray"
                        dangerouslySetInnerHTML={{ __html: highlighted }}
                />
        </>;
    };

    return <>
        {handleExport()}
    </>
}

export default TemplateDiff;